export default __webpack_public_path__ + "static/media/icon-sun.14e587b1.svg";